import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRolesInitialState, IRolesPayload } from "../types";
import { GetDeleteRoles, GetRoles } from "./thunk";

const initialState: IRolesInitialState = {
    roles: [],
    filterRole: [],
    rolesRestore: [],
    isLoadingRoles: false,
    isViewRolesRestore: false,
    selectedRoleIDs: [],
};

const rolesSlice = createSlice({
    name: "roles",
    initialState,
    reducers: {
        setRoles: (state, action: PayloadAction<{ data: IRolesPayload[]; defaultLanguage: string }>) => {
            const { data, defaultLanguage } = action.payload;
            state.roles = data;
            state.filterRole = data.flatMap(data =>
                data.translations
                    .filter(elem => elem.slug === defaultLanguage && elem.name)
                    .map(elem => ({
                        id: data.id,
                        name: elem.name as string,
                    }))
            );
        },
        setRolesRestore: (state, action) => {
            state.rolesRestore = action.payload;
        },
        setIsViewRolesRestore: state => {
            state.isViewRolesRestore = !state.isViewRolesRestore;
        },
        deletedRoles: (state, action: PayloadAction<number>) => {
            state.roles = state.roles.filter(elem => elem.id !== action.payload);
        },
        deletedRestoreRoles: (state, action) => {
            state.rolesRestore = state.rolesRestore.filter(elem => elem.id !== action.payload);
        },
        setSelectedRoleIDs: (state, action) => {
            state.selectedRoleIDs = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetRoles.pending, state => {
                state.isLoadingRoles = true;
            })
            .addCase(GetRoles.fulfilled, state => {
                state.isLoadingRoles = false;
            })
            .addCase(GetRoles.rejected, state => {
                state.isLoadingRoles = false;
            })
            .addCase(GetDeleteRoles.pending, state => {
                state.isLoadingRoles = true;
            })
            .addCase(GetDeleteRoles.fulfilled, state => {
                state.isLoadingRoles = false;
            })
            .addCase(GetDeleteRoles.rejected, state => {
                state.isLoadingRoles = false;
            });
    },
});

export const {
    setRoles,
    setRolesRestore,
    setIsViewRolesRestore,
    deletedRoles,
    deletedRestoreRoles,
    setSelectedRoleIDs,
} = rolesSlice.actions;

export default rolesSlice;
